// export const BASE_URL_API = 'https://cors-anywhere.herokuapp.com/https://stylelink.in/andromeda/web/apis';
export const BASE_URL_API = 'https://stylelink.in/andromeda/web/apis';
